var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.0001V7.00006C7.99904 6.02579 8.35369 5.08467 8.99738 4.35333C9.64107 3.62199 10.5295 3.15072 11.496 3.02798C12.4625 2.90523 13.4406 3.13945 14.2467 3.68667C15.0528 4.23388 15.6314 5.05648 15.874 6.00006C16.1166 6.94363 16 9.5 16 9.5",
    stroke: "#F79009",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10H19V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V10Z",
    fill: "#F79009",
    stroke: "#F79009",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.5H14.51V15.51H14.5V15.5Z",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedUser);
export default __webpack_public_path__ + "static/media/LockedUser.b24c41354b42967a694465ee86c5bb3a.svg";
export { ForwardRef as ReactComponent };